<template>
  <v-card>
    <v-card-title style="background-color: #004056" class="white--text">
      Open this Lead?
    </v-card-title>

    <v-divider />

    <v-card-text class="mt-4">
      <div><strong>Yes I want this lead!</strong></div>
      <div class="mt-5">You will be charged {{ formatCurrency(lead.price_cents) }} <em>(plus tax)</em>.</div>
    </v-card-text>

    <v-divider />

    <v-card-actions class="justify-center py-3">
      <v-btn @click="close">Cancel</v-btn>
      <v-btn color="primary" @click="confirm">Confirm</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import formatters from '@/lib/formatters'

export default {
  name: 'UnopenedLeadSufficient',

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...formatters,

    close() {
      this.$emit('close')
    },

    confirm() {
      this.$router.push( { name: 'leads', params: { lead_id: this.lead.lead_id }})
    },
  }
}
</script>